const o = {
  base: {
    borderRadius: "xxl",
    "& ": (r) => ({
      ...r.inheritIconColor()
    }),
    ":focus-visible": (r) => ({
      ...r.outline({ color: "primary", radius: "xxxl" })
    })
  },
  primary: {
    "&": (r) => ({
      ...r.hover({
        bg: "black"
      })
    }),
    "&:disabled": {
      bg: "cardOverlay"
    }
  },
  secondary: {
    bg: "cardOverlay",
    "&:disabled": {
      bg: "cardOverlay"
    }
  },
  ghost: {
    "&": (r) => ({
      ...r.hover({
        bg: "lightGray3"
      })
    })
  }
}, a = {
  buttons: o
};
export {
  a as buttonsTheme
};
